import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaitaxifare() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Taxi Fare',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Taxi Fare',
    headingDescription: 'Sai Trupti Cabs offers affordable and transparent Pune to Mumbai taxi fare options, designed to suit every traveler’s budget and comfort. Our pricing is fully inclusive with no hidden charges — you pay only for what you travel. Whether you choose a Sedan, SUV, or Luxury vehicle, each cab provides air-conditioned comfort, clean interiors, and smooth performance for a stress-free journey. Professional, background-verified chauffeurs ensure timely pickups and safe driving throughout your trip. Sai Trupti Cabs also offers flexible booking for one-way and round trips, airport drops, and corporate transfers at the most competitive rates. Enjoy reliable service, transparent Pune to Mumbai taxi fares, and exceptional comfort — all with Sai Trupti Cabs, your trusted intercity travel partner.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Taxi Fare",
    "description": "Pune to Mumbai Taxi Fare provides travelers with transparent and competitive pricing for intercity cab journeys. The fare structure is designed to suit every budget, offering options for hatchbacks, sedans, SUVs, and luxury vehicles. Whether you’re traveling for business, family outings, or airport transfers, you receive upfront fare details with no hidden costs. Customers can choose from one-way or round-trip packages, both priced to deliver maximum value. With flexible payment options, real-time fare estimates, and clear invoicing, Pune to Mumbai Taxi Fare ensures peace of mind and affordability for every traveler seeking a smooth and economical ride."
  },
  {
    "name": "Pune to Mumbai Cab Fare",
    "description": "Pune to Mumbai Cab Fare helps passengers understand the cost breakdown for their intercity travel between Pune and Mumbai. The pricing model includes fuel, driver allowances, and tolls (where applicable), ensuring clarity before booking. Customers can view fare comparisons across different car types such as sedans, Innovas, and premium models. Designed for transparency and convenience, the service offers instant fare quotes via online booking or customer support. With its commitment to fair pricing, Pune to Mumbai Cab Fare empowers travelers to make informed decisions while enjoying a reliable and comfortable journey."
  },
  {
    "name": "Pune to Mumbai Car Rental Cost",
    "description": "Pune to Mumbai Car Rental Cost provides detailed information on rental pricing for various vehicles, helping travelers choose the best option for their trip. Rates vary based on car model, distance, and duration of hire, giving customers flexibility to tailor their journey to their budget. From economical hatchbacks for solo travelers to luxury sedans and SUVs for executives, every rental includes transparent billing and no surprise charges. The service also allows customers to calculate per-kilometer rates, ensuring a complete understanding of trip costs. Pune to Mumbai Car Rental Cost stands out for its honesty, flexibility, and customer-first approach."
  },
  {
    "name": "Pune to Mumbai Innova Fare",
    "description": "Pune to Mumbai Innova Fare offers clear and detailed pricing for Toyota Innova rentals — one of the most popular choices for families, business groups, and outstation travelers. Known for comfort, spacious seating, and smooth performance, Innovas are available at competitive rates for one-way and round trips. The fare includes driver allowances, fuel charges, and taxes for a fully transparent experience. Customers can easily view and compare prices online, with special discounts for early bookings and corporate clients. Pune to Mumbai Innova Fare ensures that every traveler enjoys luxury and reliability at an affordable price point."
  },
  {
    "name": "Pune to Mumbai Ertiga Fare",
    "description": "Pune to Mumbai Ertiga Fare provides affordable pricing for Maruti Ertiga rentals, ideal for small families or groups seeking economical yet comfortable intercity transport. The fare includes air-conditioned vehicles, experienced chauffeurs, and clean interiors, ensuring pleasant travel throughout the journey. Customers can select one-way or round-trip packages with complete fare transparency and no hidden costs. With Ertigas offering excellent mileage and roomy interiors, Pune to Mumbai Ertiga Fare is the perfect balance of comfort and value, making it a preferred choice for travelers on a budget."
  },
  {
    "name": "Pune to Mumbai One Way Taxi Price",
    "description": "Pune to Mumbai One Way Taxi Price highlights the cost benefits of choosing a one-way trip for those who don’t need a return ride. Customers save significantly as they are charged only for a single journey, not for both directions. Fare options are available across multiple car categories, from compact cars to premium sedans and Innovas. The service ensures real-time price updates, flexible payment modes, and full cost transparency. Pune to Mumbai One Way Taxi Price is designed for travelers looking for affordability and convenience without compromising on safety or comfort."
  },
  {
    "name": "Pune to Mumbai Drop Fare",
    "description": "Pune to Mumbai Drop Fare offers competitive rates for passengers requiring only a one-time drop to Mumbai. This service eliminates return charges, making it perfect for airport transfers, business meetings, or short trips. The fare structure is straightforward, covering fuel, driver allowances, and tolls, with options to book online or via customer care. The service offers both economy and premium vehicles depending on passenger preferences. Pune to Mumbai Drop Fare guarantees safe, efficient, and affordable travel for those who prioritize punctuality and transparency in pricing."
  },
  {
    "name": "Pune to Mumbai Outstation Taxi Fare",
    "description": "Pune to Mumbai Outstation Taxi Fare provides pricing for travelers seeking long-distance cab rentals between Pune and Mumbai or beyond. The fare plans include options for one-way, round-trip, and multi-day journeys, ensuring flexibility for different travel needs. Each fare includes detailed cost breakdowns with transparent billing and no hidden extras. Customers benefit from comfortable, sanitized cars and professional chauffeurs familiar with intercity routes. Pune to Mumbai Outstation Taxi Fare is ideal for tourists, families, and corporate clients who want dependable travel with fair and competitive pricing."
  },
  {
    "name": "Pune to Mumbai Sedan Fare",
    "description": "Pune to Mumbai Sedan Fare provides elegant travel options at affordable prices for individuals and small families. With popular models like Honda City, Hyundai Verna, and Toyota Etios, sedans combine comfort with class. The fare includes fuel and driver costs with clear upfront pricing for one-way and round trips. This service is well-suited for corporate transfers, airport rides, and personal travel. Pune to Mumbai Sedan Fare ensures every customer experiences smooth, private, and affordable travel without worrying about unexpected charges or delays."
  },
  {
    "name": "Pune to Mumbai Luxury Taxi Fare",
    "description": "Pune to Mumbai Luxury Taxi Fare offers premium intercity travel at transparent and competitive prices. Travelers can choose from high-end cars such as BMW, Audi, or Mercedes, ideal for executives, VIPs, or special occasions. The fare includes chauffeur service, comfort features, and all standard charges like tolls and fuel. Each booking guarantees privacy, elegance, and top-tier comfort throughout the journey. Pune to Mumbai Luxury Taxi Fare is perfect for travelers who value class and reliability while enjoying the convenience of fixed-rate pricing and premium service."
  },
  {
    "name": "Affordable Pune to Mumbai Cab",
    "description": "Affordable Pune to Mumbai Cab provides cost-effective transportation solutions for travelers who prioritize value without sacrificing quality. Offering a diverse fleet of vehicles, from compact cars to Innovas, the service ensures competitive fares, experienced drivers, and safe travel. Customers receive transparent quotes with no hidden fees, ensuring trust and satisfaction. Whether it’s for business, leisure, or airport transfers, Affordable Pune to Mumbai Cab remains a top choice for economical, dependable, and comfortable intercity commuting between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Online Fare Calculator",
    "description": "Pune to Mumbai Online Fare Calculator allows passengers to instantly estimate travel costs with just a few clicks. By entering trip details such as distance, car type, and route, customers can view accurate fare projections before booking. The tool helps users compare vehicle categories, understand additional costs like tolls or waiting time, and choose the best option for their budget. Designed for transparency and convenience, the Pune to Mumbai Online Fare Calculator empowers travelers to plan their journeys confidently, avoiding last-minute surprises."
  },
  {
    "name": "Pune to Mumbai Car Hire Cost",
    "description": "Pune to Mumbai Car Hire Cost outlines detailed pricing structures for customers renting cars for one-way, round-trip, or extended travel. Rates depend on car model, travel duration, and distance, with flexible options for hourly or per-kilometer billing. The service ensures no hidden charges and provides complete breakdowns of fuel, driver, and toll expenses. Whether renting for corporate purposes or family travel, Pune to Mumbai Car Hire Cost helps customers make informed choices while ensuring comfort and affordability at every stage of the journey."
  },
  {
    "name": "Pune to Mumbai Trip Cost",
    "description": "Pune to Mumbai Trip Cost helps passengers understand total travel expenses, including vehicle fare, tolls, and other applicable charges. The service provides clear insights into how distance, travel time, and car type affect the total cost. Travelers can choose from affordable sedans to premium cars depending on budget and requirements. With instant fare calculations and easy comparisons, Pune to Mumbai Trip Cost ensures transparency and confidence in every booking, enabling travelers to plan efficiently without overspending."
  },
  {
    "name": "Pune to Mumbai Fare Estimate",
    "description": "Pune to Mumbai Fare Estimate offers an easy way to predict total travel costs for intercity journeys. It factors in distance, traffic conditions, vehicle choice, and route to generate accurate and fair fare predictions. Customers can view the estimated range before confirming their booking, ensuring no surprises later. Designed to provide clarity and confidence, the Pune to Mumbai Fare Estimate tool helps travelers plan their trips smartly, balancing comfort and cost efficiency for a stress-free travel experience."
  }
],
"tableData": [
  ["Pune to Mumbai Taxi Fare", "Pune to Mumbai Cab Fare"],
  ["Pune to Mumbai Car Rental Cost", "Pune to Mumbai Innova Fare"],
  ["Pune to Mumbai Ertiga Fare", "Pune to Mumbai One Way Taxi Price"],
  ["Pune to Mumbai Drop Fare", "Pune to Mumbai Outstation Taxi Fare"],
  ["Pune to Mumbai Sedan Fare", "Pune to Mumbai Luxury Taxi Fare"],
  ["Affordable Pune to Mumbai Cab", "Pune to Mumbai Online Fare Calculator"],
  ["Pune to Mumbai Car Hire Cost", "Pune to Mumbai Trip Cost"],
  ["Pune to Mumbai Fare Estimate", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Taxi Fare Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers transparent and affordable taxi fare services from Pune to Mumbai, ensuring a hassle-free and comfortable journey."
  },
  {
    "WhyChooseheading": "Competitive and Clear Pricing",
    "WhyChoosedescription": "Our fares are transparent and competitive, with no hidden charges, so you know exactly what you will pay for your Pune to Mumbai trip."
  },
  {
    "WhyChooseheading": "Variety of Vehicles",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to match your group size, luggage, and comfort requirements."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune–Mumbai route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Options",
    "WhyChoosedescription": "We provide convenient pickups and drop-offs across Pune and Mumbai, including airports, railway stations, and city locations."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our taxis are well-maintained, sanitized, and equipped for a relaxing long-distance ride."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist with fare inquiries, bookings, and travel support."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai taxi easily via call, WhatsApp, or our website, with instant confirmation and prompt dispatch."
  }
]



















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai taxi services?',
    answer: 'Yes, Sai Trupti Cabs  offers reliable Pune to Mumbai taxi services with transparent and affordable fares for one way and round trips.',
  },
  {
    question: 'What is the Pune to Mumbai taxi fare with Sai Trupti Cabs?',
    answer: 'The Pune to Mumbai taxi fare starts from ₹1,500 for hatchbacks, ₹1,800–₹2,500 for sedans, and ₹3,000 onwards for SUVs, depending on your travel requirements and vehicle type.',
  },
  {
    question: 'How can I book a Pune to Mumbai taxi with Sai Trupti Cabs?',
    answer: 'You can easily book a Pune to Mumbai taxi through our website, mobile app, or by calling our 24×7 customer support team.',
  },
  {
    question: 'Are the fares inclusive of tolls and taxes for the Pune to Mumbai route?',
    answer: 'Yes, our fares are transparent. Tolls, state taxes, and driver allowances are either included or clearly mentioned during booking, ensuring no hidden charges.',
  },
  {
    question: 'Can I book a one way or round trip taxi from Pune to Mumbai?',
    answer: 'Certainly. Sai Trupti Cabs offers both one way and round trip taxi options for your convenience between Pune and Mumbai.',
  },
  {
    question: 'Are Sai Trupti Cabs available 24×7 for Pune to Mumbai travel?',
    answer: 'Yes, we provide 24×7 taxi services for Pune to Mumbai, ideal for airport transfers, business trips, and leisure travel.',
  },
  {
    question: 'What types of taxis are available for Pune to Mumbai rides?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars for comfortable travel from Pune to Mumbai.',
  },
  {
    question: 'What safety and hygiene protocols are followed during Pune to Mumbai taxi rides?',
    answer: 'All our taxis are sanitized before every ride, and our drivers follow proper safety and hygiene standards for a safe journey.',
  },
  {
    question: 'What payment options are available for Pune to Mumbai taxi bookings?',
    answer: 'We accept multiple payment methods including UPI, debit/credit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'Is customer support available during my Pune to Mumbai taxi trip?',
    answer: 'Yes, Sai Trupti Cabs provides 24×7 customer support throughout your Pune to Mumbai travel experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nilesh Kadam',
    feedback: 'I booked a Pune to Mumbai taxi with Sai Trupti Cabs and got a great fare. The car was comfortable and the driver was on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Sai Trupti Cabs provided an affordable Pune to Mumbai taxi fare with excellent service. Transparent pricing and a smooth journey!',
    rating: 5,
  },
];
























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Taxi Fare",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-taxi-fare.jpg",
  "description": "Check Pune to Mumbai Taxi Fare with Sai Trupti Cabs for the best and most affordable rates. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Get transparent pricing, 24/7 booking, and professional drivers for a safe and comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16321"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-taxi-fare"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Taxi Fare | Best Price Guarantee | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Check Pune to Mumbai Taxi Fare with Sai Trupti Cabs for the best and most affordable rates. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Get transparent pricing, 24/7 booking, and professional drivers for a safe and comfortable journey." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Taxi Fare, Pune to Mumbai Cab Fare, Pune to Mumbai Car Rental Cost, Pune to Mumbai Innova Fare, Pune to Mumbai Ertiga Fare, Pune to Mumbai One Way Taxi Price, Pune to Mumbai Drop Fare, Pune to Mumbai Outstation Taxi Fare, Pune to Mumbai Sedan Fare, Pune to Mumbai Luxury Taxi Fare, Affordable Pune to Mumbai Cab, Pune to Mumbai Online Fare Calculator, Pune to Mumbai Car Hire Cost, Pune to Mumbai Trip Cost, Pune to Mumbai Fare Estimate" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaitaxifare;